<template>
    <article class="sidebar-folding-container">
        <section class="sidebar-wrapper">
            <div class="user-info">
                <!-- 로고 -->
                <a href="https://www.risingx.co.kr/DashBoard" @click="windowTopHandler">
                    <img
                        src="@/assets/images/layouts/sideBar/logo_sum.svg"
                        alt=""
                    />
                </a>

                <!-- 유저 이미지 -->
                <!-- <span class="profile__img">
                    <img :src="userInfo.imageUrl" alt="" />
                </span> -->

                <!-- 유저 구독 정보 -->
                <!-- <div class="subscribe">
                    <ul class="highlight">
                        <li>0000</li>
                        <li>00.00</li>
                    </ul> -->
                    <!-- <ul class="highlight">
                        <li>{{ props.userInfo.subscribe.slice(0, 4) }}</li>
                        <li>{{ props.userInfo.subscribe.slice(5) }}</li>
                        <li class="notice__resubscribe">
                            Resubscribe
                        </li>
                    </ul> -->
                <!-- </div> -->

                <!-- 마이페이지 -->
                <!-- <div class="mypage">
                    <p class="highlight">MY</p>
                </div> -->
            </div>

            <!-- 메인 메뉴 -->
            <div class="scroll" @scroll="() => menuHandler()">
                <div class="category">
                    <ul>
                        <li
                            v-for="mainMenu in mainMenus"
                            :key="mainMenu"
                            :class="[`folding-menu`, mainMenu.key]"
                            ref="menuRefs"
                            @click="menuHandler(mainMenu.key, mainMenu)"
                            @mouseenter="hoverHandler('enter', mainMenu)"
                            @mouseleave="hoverHandler('leave', mainMenu)"
                        >
                            <span class="menu-icon" @click="menuClickHandler(mainMenu)">
                                <img :src="mainMenu.isActive || menuHover[mainMenu.key] || menuClick[mainMenu.key] && mainMenu.beta ? mainMenu.activeIcon : mainMenu.icon" />
                            </span>
                            <div v-if="mainMenu.showHr" class="gradient-line"></div>
                        </li>
                    </ul>

                    <!-- sns -->
                    <div class="menu__sns">
                        <div @click="snsHandler" class="btn__sns">
                            <span class="highlight">+{{ snsList.length }}</span>
                        </div>
                    </div>

                </div>
            </div>

            <Transition name="fade">
                <div
                    v-if="snsPopup.isActive" class="share-link-wrapper"
                    :style="{top: `${snsPopup.position}px`}"
                >
                    <div v-for="sns in snsList" :key="sns" class="share-link-container">
                        <a
                            :href="sns.link"
                            class="share-link"
                            target="_blank"
                        >
                            <img :src="sns.activeIcon" alt="sns.key" class="img" />
                        </a>
                    </div>


                </div>

            </Transition>
        </section>

        <!-- sub menu -->
        <template v-for="mainMenu in mainMenus" :key="mainMenu">
            <div v-if="menuBg" class="menu-overlay" @mousedown="handleOverlay"></div>
            <div
                :class="[`submenu-container`, mainMenu.key]"
                :style="{top: `${hoveredItem[mainMenu.key].position}px`}"
            >
                <Transition name="fade">
                    <ul v-if="mainMenu.hasSubmenu && mainMenu.beta && menuClick[mainMenu.key]" class="folding-submenu">
                        <li v-for="subMenu in mainMenu.subMenu" :key="subMenu" class="submenu">
                            <span
                                class="submenu-category highlight"
                                :class="[!subMenu.beta ? 'disable-menu' : '', subMenu.isActive ? 'menu-active' : '']"
                                @click="subMenuClickHandler(subMenu)"
                                @mouseenter="hoverHandler('enter', subMenu)"
                                @mouseleave="hoverHandler('leave', subMenu)"
                            >
                                <span class="submenu-icon">
                                    <img :src="subMenu.isActive || menuHover[subMenu.key] && subMenu.beta ? subMenu.activeIcon : subMenu.icon" />
                                </span>
                                {{ $t(subMenu.label) }}
                            </span>
                        </li>
                    </ul>
                </Transition>
            </div>
        </template>

    </article>
</template>

<script setup>
import {ref,computed,watch, onMounted} from 'vue';
import {useRouter} from 'vue-router';
import { useStore } from 'vuex';
// import Store from '@/assets/images/layouts/sideBar/storeMenu/dashboard.svg'
// import { getNumberByNaN } from "@/client_api/util.js";

// const props = defineProps({
//     userInfo      : Object,
// });
const store = useStore();
const mainMenus = computed(()=> store.getters['useMainMenuList/mainMenuItems'])
const snsList = ref([]);

onMounted(async () => {
  snsList.value = await store.dispatch('useSnsList/snsItems');
//   console.log(snsList.value);
});
const router = useRouter()

const snsPopup       = ref({});
const hoveredItem    = ref({});
const menuRefs       = ref([]);
const menuBg         = ref(false);

mainMenus.value.forEach(ob => {
    if(!hoveredItem.value[ob.key]) {
        hoveredItem.value[ob.key] = {
            isActive: false,
            position: 0,
        };
    }
});


const menuClickHandler = (item) => {
    // popupStore.openBetaPopup(false);
    store.dispatch('usePopupList/openBetaPopup', false);
    if(!item.beta) {
        store.dispatch('usePopupList/openBetaPopup', true);
        // popupStore.openBetaPopup(true);
        return;
    }

    if(!item.hasSubmenu) router.push(item.route)
}

const subMenuClickHandler = (item) => {
    store.dispatch('usePopupList/openBetaPopup', false);
    // popupStore.openBetaPopup(false);
    if(!item.beta) {
        store.dispatch('usePopupList/openBetaPopup', true);
        // popupStore.openBetaPopup(true);
        return;
    }

    store.dispatch('useMainMenuList/setMenuStatus', item.key);

    router.push({
        path : item.route,
        query: {
            menuName : item.key
        },
    })
}

const menuClick     = ref({});
const menuHover     = ref({});
const menuKeyArr    = mainMenus.value.map(ob => ob.key).filter(ob => ob);

menuKeyArr.forEach(ob => {
    menuHover.value[ob] = false;
    menuClick.value[ob] = false;
});

function menuHandler(key, item) {
    menuBg.value = true;

    if(!key && !item) {
        const menuStatus = Object.values(menuClick.value);

        if(menuStatus.every(ob => !ob) && !snsPopup.value.isActive) return;
        for(const [key] of Object.entries(menuClick.value)) {
            menuClick.value[key] = false;
        }
        snsPopup.value.isActive = false;
        return;
    }
    for(const [key] of Object.entries(menuClick.value)) {
        menuClick.value[key] = false;
    }
    menuClick.value[item.key] = !menuClick.value[item.key];

    for(const [itemKey] of Object.entries(hoveredItem.value)) {
        hoveredItem.value[itemKey].isActive = false;
    }

    const $menuItem = menuRefs.value.find(ob => ob.classList.contains(key));
    if(!$menuItem) return;
    hoveredItem.value[key].isActive = true;

    hoveredItem.value[key].position = $menuItem.getBoundingClientRect().top - 55;
}

const snsHandler = (e) => {
    const top = e.target.getBoundingClientRect().top - 48;

    snsPopup.value.isActive = !snsPopup.value.isActive;
    snsPopup.value.position = top;
}

const hoverHandler = (type, item) => {
    if (item.beta) {
        switch(type) {
            case "enter":
                menuHover.value[item.key] = true;
                break;
            case "leave":
                menuHover.value[item.key] = false;
                break;
        }
    }
}

watch(mainMenus, () => {
    menuHandler();
    menuBg.value = false;
});

const handleOverlay = () => {
    menuHandler();
    menuBg.value = false;
}

const windowTopHandler = () => {
    window.scrollTo({top: 0, behavior:"smooth"})
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/after/SideBarFolding.scss";
</style>
